import { Box, LinearProgress } from '@mui/material';

import {
  BarStacked1D,
  ConfigurationMap,
  Project,
  ScoreCard,
  TextResult,
} from '@arra/core';
import { User } from '../../../authentication/context/useUser';
import Markdown from '../../../ui/Markdown';
import social from '../images/Utilite sociale.svg';
import { ContentLayout, PageLayout, Text } from '../layout';
import { PdfAbacus } from '../PdfAbacus';
import PdfBarStacked1D from '../PdfBarStacked1D';
import { Footer } from './Footer';
import { Header } from './Header';

export const SocialUtility = ({
  project,
  user,
  configuration,
}: {
  project: Project;
  user: User;
  configuration: ConfigurationMap | undefined;
}) => {
  if (!project || !user || !configuration) {
    return null;
  }

  const socialUtilityConfig = configuration['pdfResults.config'].socialUtilityPage;

  const {
    resultCode,
    descriptionTextCode,
    detailedResult1Code,
    detailedResult2Code,
  } = socialUtilityConfig;

  const socialResult = project.results.find(
    (result) => result.code === resultCode,
  ) as ScoreCard;

  const SocialScoreString = socialResult?.score;

  const socialScore = SocialScoreString
    ? parseInt(SocialScoreString.split('/')[0])
    : 0;

  const socialDescription = project.results.find(
    (result) => result.code === descriptionTextCode,
  ) as TextResult;

  const socialDetails1 = project.results.find(
    (result) => result.code === detailedResult1Code,
  ) as BarStacked1D;

  const socialDetails2 = project.results.find(
    (result) => result.code === detailedResult2Code,
  ) as BarStacked1D;

  return (
    <PageLayout>
      <Header project={project} pageNumber={2} />
      <ContentLayout color="var(--LITTLECORAL)">
        <Box height="30px" />
        <Box display="flex" columnGap={3} alignItems="center">
          <img src={social} width="80px" alt="social" />
          <Text fontSize="70px" fontWeight="bold">
            Utilité sociale
          </Text>
        </Box>
        <Box height="30px" />
        <Box
          height="1px"
          width="100%"
          sx={{
            background:
              'repeating-linear-gradient(90deg,var(--LITTLECORAL) 0 20px,white 0 40px)',
          }}
        />
        <Box
          display="flex"
          justifyContent="space-evenly"
          alignItems="center"
          columnGap={5}
          width="100%"
          padding="24px 5% 16px 5%"
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <Text fontSize="25px" fontWeight="bold">
              Score d'utilité sociale
            </Text>
            <Box display="flex" paddingLeft="10px" alignItems="center">
              <Text
                fontSize="90px"
                color="var(--LITTLECORAL)"
                fontWeight="bold"
              >
                {socialScore}
              </Text>
              <Box>
                <Text fontSize="30px" fontWeight="bold">
                  /100
                </Text>
                <Box height="10px" />
                <LinearProgress
                  variant="determinate"
                  sx={{ color: 'var(--yellow)' }}
                  value={socialScore}
                />
              </Box>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            rowGap="30px"
            alignItems="center"
            width="100%"
          >
            <PdfAbacus result={socialResult} visible={true} />
          </Box>
        </Box>
        {socialDescription && socialDescription.text && (
          <>
            <Box display="flex" width="100%" mt={1} pr={10} justifyContent="flex-start">
              <Text
                fontSize="12px"
                textAlign="left"
                style={{ width: '100%' }}
              >
                <Markdown>{socialDescription.text}</Markdown>
              </Text>
            </Box>
            <Box height="30px" />
          </>
        )}
        <Box
          width="100%"
          flex={1}
          display="flex"
          gap={2}
          flexDirection="column"
          justifyContent="flex-start"
        >
          <Box width="100%" height="200px">
            <PdfBarStacked1D result={socialDetails1} />
          </Box>
          <Box width="100%" height="200px">
            <PdfBarStacked1D result={socialDetails2} />
          </Box>
        </Box>
      </ContentLayout>
      <Footer project={project} user={user} />
    </PageLayout>
  );
};
